<template>
  <div></div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: 'appAlert',
  mounted () {
    this.$bus.$on('alert-on', data => {
      this.confirm(data.title, data.question, data.isImportant)
    })
    this.$bus.$on('alert-sucess', data => {
      this.showSuccess(data.title, data.message)
    })
    this.$bus.$on('alert-error', data => {
      this.showError(data.title, data.error, data.confirmButtonText)
    })
    this.$bus.$on('alert-warning', data => {
      this.showWarning(data.title, data.message)
    })
  },
  methods: {
    confirm (title, question, isImportant = false) {
      swal({
        title: title,
        text: question,
        type: 'warning',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCancelButton: true,
        focusConfirm: false,
        focusCancel: true,
        allowOutsideClick: false,
        reverseButtons: true,
        onClose: () => {
          console.log('fechou')
        }
      }).then(result => this.$bus.$emit('alert-response', result))
    },
    showError (title, error, confirmButtonText = 'Ok') {
      swal({
        title: title,
        text: error,
        type: 'error',
        allowOutsideClick: false,
        confirmButtonText: confirmButtonText,
        onClose: () => swal.close()
      }).then(() => this.$bus.$emit('alert-response'))
    },
    showSuccess (title, message) {
      swal({
        title: title,
        text: message,
        type: 'success',
        allowOutsideClick: false
      }).then(() => this.$bus.$emit('alert-response'))
    },
    showWarning (title, message) {
      swal({
        title: title,
        text: message,
        type: 'warning',
        allowOutsideClick: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/theme/Alert.vue